module.exports = __webpack_public_path__ + "img/v3-note-light.25d3e970.svg";